import React, { useState } from "react";
import TextInput, { TextField } from "./TextField";
import EyeVisibleIcon from "components/shared/ui/icons/EyeVisibleIcon";
import EyeHiddenIcon from "components/shared/ui/icons/EyeHiddenIcon";
import styles from "./TextField.module.scss";
import {
  IInput,
  IInputField
} from "components/shared/ui/form-elements/FormikElements";

interface IPasswordWrap extends IInputField {
  component: typeof TextInput | typeof TextField;
}

const PasswordTextWrapper = ({
  component: Component,
  ...props
}: IPasswordWrap) => {
  const [displayPassword, toggleDisplay] = useState(false);
  return (
    <div className={styles.passwordWrapper}>
      <Component {...props} type={displayPassword ? "text" : "password"} />
      <div
        className={styles.toggle}
        onClick={() => toggleDisplay(!displayPassword)}
      >
        {displayPassword ? <EyeVisibleIcon /> : <EyeHiddenIcon />}{" "}
      </div>
    </div>
  );
};

const PasswordTextInput = (props: IInput) => (
  <PasswordTextWrapper component={TextInput} {...props} />
);

export const PasswordTextField = (props: IInputField) => (
  <PasswordTextWrapper component={TextField} {...props} />
);

export default PasswordTextInput;
